export const environment = {
  production: true,
  instrumentationKey: "",
  apiUrl: "https://eth-api-dev.azure.chevron.com",
  redirectUri: "https://eth-dev.azure.chevron.com",
  msalClientId: "9ddbaa91-c8c1-4099-9b2f-c4ed165633b2",
  msalAuthority: "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  apiScope: "https://whc-dev.azure.chevron.com/user_impersonation",
  // Entra ID group whose members and owners are granted Admin access.
  adminGroupId: "107c0010-eb8b-4f6f-a0e1-1ced0966a9a2",
};
